var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-input", {
        staticStyle: { "margin-bottom": "10px" },
        attrs: { placeholder: "请输入收货地址" },
        model: {
          value: _vm.raddress,
          callback: function ($$v) {
            _vm.raddress = $$v
          },
          expression: "raddress",
        },
      }),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-bottom": "10px" },
          attrs: { data: _vm.contacts, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { label: "联系人", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { placeholder: "请输入联系人" },
                      model: {
                        value: scope.row.name,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "name", $$v)
                        },
                        expression: "scope.row.name",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "手机", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { placeholder: "请输入手机号" },
                      model: {
                        value: scope.row.phone,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "phone", $$v)
                        },
                        expression: "scope.row.phone",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "部门", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { placeholder: "请输入部门" },
                      model: {
                        value: scope.row.bumen,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "bumen", $$v)
                        },
                        expression: "scope.row.bumen",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "邮箱", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { placeholder: "请输入邮箱" },
                      model: {
                        value: scope.row.email,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "email", $$v)
                        },
                        expression: "scope.row.email",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "电话", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { placeholder: "请输入电话" },
                      model: {
                        value: scope.row.tel,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "tel", $$v)
                        },
                        expression: "scope.row.tel",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "传真", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { placeholder: "请输入传真" },
                      model: {
                        value: scope.row.max,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "max", $$v)
                        },
                        expression: "scope.row.max",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "el-icon-delete",
                        attrs: { type: "danger", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.removeContact(scope.$index)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticClass: "el-icon-plus",
          attrs: { type: "primary", size: "small" },
          on: { click: _vm.addContact },
        },
        [_vm._v("添加联系人")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }